import { render, staticRenderFns } from "./AssessmentGroupStudyUnitTable.vue?vue&type=template&id=581a9c99&scoped=true"
import script from "./AssessmentGroupStudyUnitTable.vue?vue&type=script&lang=js"
export * from "./AssessmentGroupStudyUnitTable.vue?vue&type=script&lang=js"
import style0 from "./AssessmentGroupStudyUnitTable.vue?vue&type=style&index=0&id=581a9c99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581a9c99",
  null
  
)

export default component.exports